/**
 * Logo component.
 * @module components/theme/Logo/Logo
 */

import { Icon } from '@plone/volto/components';
import { HashLink as NavLink } from 'react-router-hash-link';

import logoSVG from 'volto-proseriestools/icons/logo.svg';

/**
 * Logo component class.
 * @function Logo
 * @param {Object} intl Intl object
 * @returns {string} Markup of the component.
 */
const Logo = () => {
  return (
    <div className="logo">
      <NavLink smooth to="#top">
        <Icon name={logoSVG} title="Pro Series Tools Logo" size="80px" />
      </NavLink>
    </div>
  );
};

export default Logo;
